module.exports = require("./matches-selector.js");


//////////////////
// WEBPACK FOOTER
// desandro-matches-selector (bower component)
// module id = 1393
// module chunks = 0